import { createSlice } from "@reduxjs/toolkit";
import { get_req, post_req } from "../Utilities/apiUtil";
import {
  get_coupons_url,
  check_coupon_url,
  remove_coupon_url,
} from "../Utilities/apiUrl";
import { errorActions } from "../store/errorSlice";
import { basketActions } from "../store/basket";
import appConst from "../Utilities/appConst.json";
import { alertActions } from "./alertSlice";
import { footerActions } from "./footerSlice";
import { loaderActions } from "./loaderSlice";
import { shippingActions } from "./shippingSlice";

const getCombinations = (action) => {
  const serviceCodeOrCollectionBucketCupon =
    action.payload.coupons.messages.find(
      (message) =>
        message.message_type ==
          appConst.INPUT_COUPON_MESSAGE_TYPE_COLLECTION_BUCKET_NOTE ||
        message.message_type ==
          appConst.INPUT_COUPON_MESSAGE_TYPE_SERVICE_CODE_NOTE
    );

  const selectedCombination = serviceCodeOrCollectionBucketCupon
    ? action.payload.coupons.combinations.find(
        (combination) =>
          combination.coupon_ids.length === 1 &&
          combination.coupon_ids[0] ===
            serviceCodeOrCollectionBucketCupon.coupon_id
      )
    : action.payload.coupons.combinations.find(
        (combination) => combination.is_selected == true
      );

  const combinations = serviceCodeOrCollectionBucketCupon
    ? action.payload.coupons.combinations.map((combination) => {
        return combination === selectedCombination
          ? { ...combination, is_selected: true }
          : { ...combination, is_selected: false };
      })
    : action.payload.coupons.combinations;

  return combinations;
};

const handleCouponsMessages = (dispatch, action, couponInput) => {
  const coupon = action.payload.coupons.coupons.filter(
    (coupon) =>
      coupon.coupon_code === couponInput || coupon.coupon_name === couponInput
  );
  const message = action.payload.coupons.messages.filter(
    (message) =>
      message.coupon_code === couponInput || message.coupon_name === couponInput
  );
  const messageType =
    message.length > 0
      ? message[0].message_type
      : appConst.INPUT_COUPON_MESSAGE_TYPE_DOES_NOT_APPEAR;

  switch (messageType) {
    case appConst.INPUT_COUPON_MESSAGE_TYPE_NOT_FOUND:
    case appConst.INPUT_COUPON_MESSAGE_TYPE_ALREADY_USED:
    case appConst.INPUT_COUPON_MESSAGE_TYPE_ALREADY_ADDED:
      dispatch(
        couponsActions.setAlertMessage({
          message: action.payload.coupons.messages
            .filter(
              (message) =>
                message.coupon_code.toUpperCase() ==
                  couponInput.toUpperCase() ||
                message.coupon_code.toUpperCase() == couponInput.toUpperCase()
            )
            .map((m) => m.message)
            .join(","),
        })
      );
      break;
    case appConst.INPUT_COUPON_MESSAGE_TYPE_EXPIRED:
      dispatch(
        couponsActions.setAlertMessage({
          message: action.payload.coupons.messages
            .filter(
              (message) =>
                message.coupon_name.toUpperCase() ==
                  couponInput.toUpperCase() ||
                message.coupon_code.toUpperCase() == couponInput.toUpperCase()
            )
            .map((m) => m.message)
            .join(","),
        })
      );
      break;
    case appConst.INPUT_COUPON_MESSAGE_TYPE_MISDEFINED:
      dispatch(
        couponsActions.setAlertMessage({
          message: action.payload.coupons.messages
            .filter(
              (message) =>
                message.coupon_name.toUpperCase() ==
                  couponInput.toUpperCase() ||
                message.coupon_code.toUpperCase() == couponInput.toUpperCase()
            )
            .map((m) => m.message)
            .join(","),
        })
      );
      break;
    case appConst.INPUT_COUPON_MESSAGE_TYPE_NOT_APPLIED:
      dispatch(couponsActions.setUserCoupons(action));
      dispatch(
        alertActions.createAlert({
          title: message.length ? message[0].title : "",
          message: message.length ? message[0].message : "",
          isDialog: true,
          yesButtonText: appConst.COUPON_NOT_APPLIED_YES_BUTTON_TEXT,
          noButtonText: appConst.COUPON_NOT_APPLIED_NO_BUTTON_TEXT,
          hasNext: true,
          nextDialogTitle: appConst.COUPON_INFO_TITLE,
          nextDialogMessage: message.length
            ? message[0].terms_and_conditions
            : "",
          nextDialogOkButtonText: appConst.COUPON_NOT_APPLIED_NO_BUTTON_TEXT,
        })
      );
      break;
    case appConst.INPUT_COUPON_MESSAGE_TYPE_COLLECTION_BUCKET_NOTE:
      dispatch(couponsActions.setUserCoupons(action));
      dispatch(
        alertActions.createAlert({
          title: message.length ? message[0].title : "",
          message: message.length ? message[0].message : "",
          isDialog: false,
        })
      );
      break;
    case appConst.INPUT_COUPON_MESSAGE_TYPE_SERVICE_CODE_NOTE:
      if (coupon.length > 0) {
        dispatch(couponsActions.setUserCoupons(action));
      }
      dispatch(
        alertActions.createAlert({
          title: message.length ? message[0].title : "",
          message: message.length ? message[0].message : "",
          isDialog: false,
        })
      );
      break;
    case appConst.INPUT_COUPON_MESSAGE_TYPE_COUPON_PARTIAL_USEG:
      dispatch(couponsActions.setUserCoupons(action));
      break;
    default:
      dispatch(couponsActions.setUserCoupons(action));
  }
  dispatch(loaderActions.loaderHide());
};

const withCombinations = (action, combinations) => ({
  ...action,
  payload: {
    ...action.payload,
    coupons: { ...action.payload.coupons, combinations: combinations },
  },
});

const applyCouponsData = async (dispatch, data) => {
  const selectedCombination = data.payload.coupons.combinations.find(
    (combination) => combination.is_selected === true
  );

  // Using Promise.all to wait for all dispatches to complete
  await Promise.all([
    dispatch(couponsActions.setUserCoupons(data)),
    dispatch(
      basketActions.setBasketFromCoupons({
        payments: data.payload.payments,
        finalPrice: selectedCombination.total_final_price,
        // finalPrice: selectedCombination.final_price,
        invoiceItems: data.payload.invoice.items,
        items: data.payload.items,
        coupons: data.payload.coupons,
        delivery: data.payload.delivery,
        deliveryType: data.payload.delivery_details.delivery_type,
      })
    ),
    dispatch(
      footerActions.setFooterShippingFromUpdateCoupons(
        selectedCombination ? selectedCombination.delivery_final_price : 0
      )
    ),
    dispatch(
      footerActions.setFooterQunatityFromCoupons(
        data.payload.items
          .map((item) => item.quantity)
          .reduce((a, b) => a + b, 0)
      )
    ),
    dispatch(couponsActions.hideAlertMessage()),
    dispatch(basketActions.setIFrameURL("")),
  ]);
};

export const getCoupons = (shippingMethod) => {
  return async (dispatch) => {
    try {
      dispatch(loaderActions.loaderShow());
      const action = await post_req(get_coupons_url, shippingMethod);

      if (action.isValid) {
        const data = withCombinations(action, getCombinations(action));
        await applyCouponsData(dispatch, data);

        // Now you can execute additional code knowing that all dispatches are completed
        console.log("All dispatches completed");
        dispatch(couponsActions.setIsGetCouponsFinished());
      } else {
        dispatch(errorActions.setError(true));
      }
    } catch (error) {
      dispatch(errorActions.setError(true));
    }
    dispatch(loaderActions.loaderHide());
  };
};

// Re-prices the basket right before payment. The price can change after
// get_coupons ran (e.g. the user joined the newsletter elsewhere and became a
// club member), and paying with the stale basket fails on the server.
// Resolves to true when payment can continue with the current basket, or to
// false when the prices changed and the refreshed prices are now on screen.
export const refreshCouponsBeforePayment = () => {
  return async (dispatch, getState) => {
    const { coupons, shipping } = getState();
    const current = coupons.selectedCombination;
    const shippingMethod = shipping.selectedShippingMethod;

    // Collection-bucket orders are not priced through get_coupons
    if (
      !current ||
      !shippingMethod ||
      coupons.isCollectionBucketCouponFromShipping ||
      coupons.collectionBucketCoupons?.length
    ) {
      return true;
    }

    try {
      // The payment page keeps the loader until the payment iframe is ready
      dispatch(loaderActions.loaderShow());
      const action = await post_req(get_coupons_url, [shippingMethod]);
      // A failed refresh should not block payment - the server still validates
      if (!action.isValid) return true;

      const currentCouponIds = [...current.coupon_ids].sort();
      const refreshedCombinations = getCombinations(action);
      const refreshed = refreshedCombinations.find((combination) =>
        compareArrays([...combination.coupon_ids].sort(), currentCouponIds)
      );

      // Keep the current behavior unless the same coupons now cost differently
      if (
        !refreshed ||
        refreshed.total_final_price === current.total_final_price
      ) {
        return true;
      }

      // Keep the coupons the user chose instead of the server's default pick
      const combinations = refreshedCombinations.map((combination) => ({
        ...combination,
        is_selected: combination === refreshed,
      }));
      await applyCouponsData(dispatch, withCombinations(action, combinations));
      dispatch(loaderActions.loaderHide());
      return false;
    } catch (error) {
      return true;
    }
  };
};

export const postCouponInput = (
  couponInput,
  basket,
  isCollectionBucket = false
) => {
  return async (dispatch) => {
    try {
      if (!couponInput) {
        if (isCollectionBucket) {
          dispatch(
            alertActions.setIsError({
              isValid: false,
              errorMessage: appConst.INPUT_COUPON_MESSAGE_TYPE_EMPTY_TEXT,
            })
          );
        } else {
          dispatch(
            couponsActions.setAlertMessage({
              message: appConst.INPUT_COUPON_MESSAGE_TYPE_EMPTY_TEXT,
            })
          );
        }
        dispatch(loaderActions.loaderHide());
        return;
      }

      const action = await post_req(
        `${check_coupon_url}&coupon_code=${encodeURIComponent(
          couponInput
        )}&is_collection_bucket=${isCollectionBucket}`,
        basket
      );

      if (action.isValid) {
        const combinations = getCombinations(action);
        const data = {
          ...action,
          payload: {
            ...action.payload,
            coupons: { ...action.payload.coupons, combinations: combinations },
          },
        };
        const selectedCombination = data.payload.coupons.combinations.find(
          (combination) => combination.is_selected == true
        );

        dispatch(
          basketActions.setBasketFromCoupons({
            payments: data.payload.payments,
            finalPrice: combinations.filter(
              (combination) => combination.is_selected
            ).final_price,
            invoiceItems: data.payload.invoice.items,
            items: data.payload.items,
            coupons: data.payload.coupons,
            delivery: data.payload.delivery,
            deliveryType: data.payload.delivery_details.delivery_type,
          })
        );

        if (isCollectionBucket) {
          dispatch(
            footerActions.setFooterShippingFromUpdateCoupons(
              selectedCombination ? selectedCombination.delivery_final_price : 0
            )
          );

          dispatch(
            footerActions.setFooterQunatityFromCoupons(
              data.payload.items
                .map((item) => item.quantity)
                .reduce((a, b) => a + b, 0)
            )
          );

          dispatch(alertActions.closeAlert(appConst.YES));

          dispatch(couponsActions.setUserCoupons(data));
          dispatch(couponsActions.hideAlertMessage());
          dispatch(
            couponsActions.setIsCollectionBucketCouponFromShipping(true)
          );

          dispatch(shippingActions.setSelectedId({ selectedId: -1 }));
          dispatch(
            shippingActions.setSelectedShippingMethod(
              action.payload.delivery_details
            )
          );
        } else {
          handleCouponsMessages(dispatch, data, couponInput);
        }
        dispatch(basketActions.setIFrameURL(""));
      } else {
        if (isCollectionBucket) {
          dispatch(alertActions.setIsError({ ...action }));
        } else {
          dispatch(errorActions.setError(true));
        }
      }
      dispatch(loaderActions.loaderHide());
    } catch (error) {
      dispatch(errorActions.setError(true));
    }
  };
};

export const removeFromRemovableCoupons = (
  coupon,
  basket,
  isCollectionBucket = false
) => {
  return async (dispatch) => {
    try {
      const action = await post_req(
        `${remove_coupon_url}&coupon_code=${coupon.coupon_name}&is_collection_bucket=${isCollectionBucket}`,
        basket
      );

      if (action.isValid) {
        const combinations = getCombinations(action);
        const data = {
          ...action,
          payload: {
            ...action.payload,
            coupons: { ...action.payload.coupons, combinations: combinations },
          },
        };

        dispatch(
          basketActions.setBasketFromCoupons({
            payments: data.payload.payments,
            finalPrice: combinations.filter(
              (combination) => combination.is_selected
            ).final_price,
            invoiceItems: data.payload.invoice.items,
            items: data.payload.items,
            coupons: data.payload.coupons,
            delivery: data.payload.delivery,
            deliveryType: data.payload.delivery_details.delivery_type,
          })
        );

        dispatch(couponsActions.setUserCoupons(data));
      } else {
        dispatch(loaderActions.loaderHide());
        dispatch(errorActions.setError(true));
      }
    } catch (error) {
      dispatch(loaderActions.loaderHide());
      dispatch(errorActions.setError(true));
    }
  };
};

export const getCombonationById = (id) => {
  const combinations = combinations;
  const matchesCombinations = combinations.filter((c) => c.ID === id);
  return [
    ...new Map(
      matchesCombinations
        .map((combination) => combination.coupons)
        .map((item) => [item["ID"], item])
    ).values(),
  ].flat();
};

const calculateCouponsDiscounts = (
  selectedCoupons,
  removableCoupons,
  collectionBucketCoupons
) => {
  let totalCouponsDiscounts = 0;

  if (collectionBucketCoupons && collectionBucketCoupons.length) {
    for (let i = 0; i < collectionBucketCoupons.length; i++) {
      totalCouponsDiscounts += collectionBucketCoupons[i].stand_alone_value;
    }
  } else {
    for (let i = 0; i < selectedCoupons.length; i++) {
      totalCouponsDiscounts += selectedCoupons[i].stand_alone_value;
    }
    for (let i = 0; i < removableCoupons.length; i++) {
      totalCouponsDiscounts += removableCoupons[i].stand_alone_value;
    }
  }

  return totalCouponsDiscounts;
};

const compareArrays = (a, b) =>
  a.length === b.length && a.every((element, index) => element === b[index]);

const setCoupons = (state, action) => {
  state.coupons = action.payload.payload.coupons.coupons;
  state.messages = action.payload.payload.coupons.messages;
  let selectableCoupons = state.coupons.filter(
    (coupon) => coupon.display_method == appConst.SELECTABLE_COUPON
  );
  const messagecouponPartialUseg = state.messages.find(
    (message) =>
      message.message_type ==
      appConst.INPUT_COUPON_MESSAGE_TYPE_COUPON_PARTIAL_USEG
  );
  if (
    messagecouponPartialUseg &&
    selectableCoupons.find(
      (coupon) => coupon.coupon_id == messagecouponPartialUseg.coupon_id
    )
  ) {
    selectableCoupons = selectableCoupons.map((coupon) => {
      return { ...coupon, messageError: "" };
    });
    selectableCoupons.find(
      (coupon) => coupon.coupon_id == messagecouponPartialUseg.coupon_id
    ).messageError = messagecouponPartialUseg.message;
  }
  state.selectableCoupons = selectableCoupons;
  state.unavailableCoupons = state.messages.filter(
    (message) =>
      message.message_type !=
      appConst.INPUT_COUPON_MESSAGE_TYPE_COUPON_PARTIAL_USEG
  );
  state.combinations = action.payload.payload.coupons.combinations;
  state.selectedCombination = state.combinations.find(
    (combination) => combination.is_selected
  );
  const removableCoupons = state.coupons.filter(
    (coupon) =>
      coupon.is_removable == true &&
      coupon.display_method != appConst.SERVICE_CODE_COUPON && // sevice code
      (!coupon.collection_bucket_name || !coupon.collection_bucket_message) // collection bucket
  );
  const notRemovableCoupons = state.coupons.filter(
    (coupon) => coupon.is_removable == false
  );
  state.selectedCoupons = notRemovableCoupons.filter((coupon) =>
    state.selectedCombination.coupon_ids.find((id) => id === coupon.coupon_id)
  );
  state.removableCoupons = removableCoupons.filter((coupon) =>
    state.selectedCombination.coupon_ids.find((id) => id === coupon.coupon_id)
  );
  state.selectedCouponsIds = state.selectedCombination.coupon_ids;
  state.serviceCodeCoupons = state.coupons.filter(
    (coupon) => coupon.display_method == appConst.SERVICE_CODE_COUPON
  );
  state.collectionBucketCoupons = state.coupons.filter(
    (coupon) =>
      coupon.collection_bucket_name && coupon.collection_bucket_message
  );
  state.couponsParent = action.payload;
  state.items = action.payload.payload.items;
  state.isDeferred = action.payload.payload.payments.is_deferred;
  state.amountDue = action.payload.payload.payments.amount_due;
  state.payments = action.payload.payload.payments;
  state.shippingPrice = state.selectedCombination
    ? state.selectedCombination.delivery_final_price
    : 0;
  state.shippingMethod = action.payload.payload.delivery.invoice_name;
  state.totalCouponsDiscounts = calculateCouponsDiscounts(
    state.selectedCoupons,
    state.removableCoupons,
    state.collectionBucketCoupons
  );

  return state;
};

const updateSelectedCombination = (state, newSelectedCombination) => {
  // switch selected combination
  const currentSelectedCombination = state.combinations.find(
    (combination) => combination.is_selected
  );
  currentSelectedCombination.is_selected = false;
  state.selectedCombination = newSelectedCombination;
  state.selectedCombination.is_selected = true;

  // update the coupon ids
  state.selectedCouponsIds = newSelectedCombination.coupon_ids;

  // update the discount
  state.totalCouponsDiscounts =
    newSelectedCombination.total_items_base_price -
    newSelectedCombination.total_items_final_price;

  return state;
};

const couponsSlice = createSlice({
  name: "coupons",
  initialState: {
    coupons: [],
    combinations: [],
    selectableCoupons: [],
    selectedCoupons: [],
    selectedCouponsIds: [],
    selectedCombination: null,
    totalCouponsDiscounts: 0,
    couponsParent: [],
    messages: [],
    alertMessage: "",
    items: [],
    isDeferred: false,
    payments: [],
    shippingPrice: 0,
    shippingMethod: "",
    removableCoupons: [],
    serviceCodeCoupons: [],
    unavailableCoupons: [],
    isCollectionBucketCouponFromShipping: false,
    isGetCouponsFinished: false,
  },
  reducers: {
    setUserCoupons: (state, action) => {
      state = setCoupons(state, action);
      state.alertMessage = "";
    },
    addToRemovableCoupons: (state, action) => {
      state.removableCoupons.push(action.payload);
      state.totalCouponsDiscounts = calculateCouponsDiscounts(
        state.selectedCoupons,
        state.removableCoupons
      );
    },
    addToSelectedCoupons: (state, action) => {
      // find the new selected combination
      const coupon = action.payload.coupon;
      const couponId = action.payload.coupon.coupon_id;

      // add to the current selected coupon ids the new selected coupon id
      let currentCouponIds = state.selectedCouponsIds;
      currentCouponIds.push(couponId);

      // try to find a copmbination that contains the current selected coupons with the new seleceted one
      let newSelectedCombination = state.combinations.find((combination) =>
        compareArrays(combination.coupon_ids.sort(), currentCouponIds.sort())
      );

      if (newSelectedCombination) {
        state = updateSelectedCombination(state, newSelectedCombination);

        // add to removable/selected coupons the new selected coupon
        if (coupon.is_removable) {
          state.removableCoupons = state.removableCoupons.concat(coupon);
        } else {
          state.selectedCoupons = state.selectedCoupons.concat(coupon);
        }
      }
      // if there is no combination like that, find the combination that includs only the new selected coupon
      else {
        currentCouponIds = [couponId];
        newSelectedCombination = state.combinations.find((combination) =>
          compareArrays(combination.coupon_ids.sort(), currentCouponIds.sort())
        );

        if (newSelectedCombination && newSelectedCombination.coupon_ids) {
          state = updateSelectedCombination(state, newSelectedCombination);

          // reset removable/selected coupons and add only the new selected coupon
          if (action.payload.coupon.is_removable) {
            state.removableCoupons = [coupon];
            state.selectedCoupons = [];
          } else {
            state.removableCoupons = [];
            state.selectedCoupons = [coupon];
          }
        }
      }

      state.totalCouponsDiscounts = calculateCouponsDiscounts(
        state.selectedCoupons,
        state.removableCoupons
      );
    },
    removeFromSelectedCoupons: (state, action) => {
      const coupon = action.payload.coupon;
      const couponId = action.payload.coupon.coupon_id;

      // remove from the current selected coupon ids the unselected coupon id
      let newCouponIdsArray = state.selectedCouponsIds.filter(
        (id) => id !== couponId
      );

      // try to find a copmbination that contains only selected coupons (without the new unseleceted one)
      let newSelectedCombination = state.combinations.find((combination) =>
        compareArrays(combination.coupon_ids.sort(), newCouponIdsArray.sort())
      );

      if (newSelectedCombination) {
        state = updateSelectedCombination(state, newSelectedCombination);

        // remove from the removable/selected coupons the unselected coupon
        if (coupon.is_removable) {
          state.removableCoupons = state.removableCoupons.filter(
            (coupon) => coupon.coupon_id !== couponId
          );
        } else {
          state.selectedCoupons = state.selectedCoupons.filter(
            (coupon) => coupon.coupon_id !== couponId
          );
        }
      }

      state.totalCouponsDiscounts = calculateCouponsDiscounts(
        state.selectedCoupons,
        state.removableCoupons
      );
    },
    setAlertMessage: (state, action) => {
      state.alertMessage = action.payload.message;
    },
    hideAlertMessage: (state, action) => {
      state.alertMessage = "";
    },
    setIsCollectionBucketCouponFromShipping: (state, action) => {
      state.isCollectionBucketCouponFromShipping = action.payload;
    },
    setIsGetCouponsFinished: (state, action) => {
      state.isGetCouponsFinished = true;
    },
  },
});
export const couponsActions = couponsSlice.actions;
export default couponsSlice;
